module.exports = __webpack_public_path__ + "media/images/decision_making-e2f9360dd2b22dd95e68d641ba61bb49.svg";